import { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';

type Props = {
  title: string | JSX.Element;
  active: boolean;
  isShowIcon?: boolean;
  iconStyle?: string;
  isBlur?: boolean;
};

const arrowIcon = 'shared/arrow-blue.svg';
const ShowButton: FC<Props> = ({
  title,
  active,
  isShowIcon,
  iconStyle,
  isBlur
}) => {
  return (
    <div className="flex relative w-full justify-center items-center pt-6">
      <span
        className={cn(
          isBlur &&
            'w-full from-white bg-gradient-to-t from-white h-6 absolute -top-6'
        )}
      />
      <span className="fs-caption-reg text-shuttleGray underline">{title}</span>
      <div className={cn(!active && 'transform -rotate-180', 'pl-4')}>
        {isShowIcon && (
          <div
            className={cn(
              'flex items-center justify-center w-9 border border-silver rounded-full bg-white',
              iconStyle
            )}
          >
            <NextImage
              alt="arrow"
              src={arrowIcon}
              layout="fixed"
              height={10}
              width={13}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShowButton;
